
import { supabase } from "@/integrations/supabase/client";

export const checkSupabaseTable = async () => {
  console.log("checkSupabaseTable: Starting check");
  
  try {
    console.log("checkSupabaseTable: Checking Supabase subscriptions table");
    
    const { data, error } = await supabase
      .from('subscriptions')
      .select('*')
      .limit(1);
    
    if (error) {
      console.error("checkSupabaseTable: Table check error:", error);
      return {
        success: false,
        message: `Supabase error: ${error.message}`,
        data: null
      };
    }
    
    console.log("checkSupabaseTable: Table exists, sample data:", data);
    return {
      success: true,
      message: "Table exists and is accessible",
      data: data
    };
  } catch (err) {
    const errorMsg = err instanceof Error ? err.message : String(err);
    console.error("checkSupabaseTable: Error checking table:", errorMsg);
    return {
      success: false,
      message: `Error checking Supabase table: ${errorMsg}`,
      data: null
    };
  }
};

// Check if the Supabase client is initialized
export const checkSupabaseClient = () => {
  try {
    // Simple test to see if supabase client is available
    if (!supabase) {
      console.log("checkSupabaseClient: Supabase client not properly imported");
      return false;
    }
    console.log("checkSupabaseClient: Supabase client is available");
    return true;
  } catch (e) {
    console.error("checkSupabaseClient: Error accessing Supabase client:", e);
    return false;
  }
};

// For backward compatibility with window.supabaseClient
// This can be removed once all code is updated to use the imported client
export const getSupabaseClient = () => {
  return supabase;
};
